import api from '@/services/AxiosConfig';
import store from '@/store';
import { CredentialService } from './CredentialService';

export class AdminService {
  static async checkAdminStatus() {
    try {
      const credential = CredentialService.getCredential();

      if (!credential || !credential.accessToken) {
        store.dispatch('userPermission/setIsAdmin', false);
        return false;
      }

      const response = await api
        .get('/users/user-modules/is-admin', {
          headers: {
            Authorization: `Bearer ${credential.accessToken}`,
          },
        })
        .catch((error) => {
          console.error('Error checking admin status:', error);
          store.dispatch('userPermission/setIsAdmin', false);
          return false;
        });

      if (!response || !response.data) {
        store.dispatch('userPermission/setIsAdmin', false);
        return false;
      }

      const isAdminFromBody = response.data?.isAdmin || response.data?.is_admin || false;

      const isAdminFromHeader = response.headers['is_admin'] || response.headers['x-is_admin'] || response.headers['X-Is-Admin'];

      const finalAdminStatus = isAdminFromBody || isAdminFromHeader === 'true' || isAdminFromHeader === true;

      store.dispatch('userPermission/setIsAdmin', finalAdminStatus);

      return finalAdminStatus;
    } catch (error) {
      //Show detailed error for debugging
      if (error.response) {
        console.error('Admin check failed:', {
          status: error.response.status,
          message: error.response.data?.message || error.message,
        });

        if (error.response.status === 401) {
          console.warn('Token might be expired or unauthorized');
          // Optional: Dispatch logout or refresh token logic
        }
      } else {
        console.error('Unknown error checking admin status:', error);
      }

      store.dispatch('userPermission/setIsAdmin', false);
      return false;
    }
  }

  static getAdminStatus() {
    return store.getters['userPermission/getIsAdmin'] || false;
  }

  static isAdmin() {
    return this.getAdminStatus();
  }
}
